import { Api } from '@/src/store/api'

export const CardAccountsApi = Api
